// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1888":"LocationMap","3829":"FahrzeugDetails","5706":"InstallDoc","9583":"Standorte"}[chunkId] + "." + {"1888":"b55a03e0","3829":"016293ee","5706":"ebc18cf8","9583":"b55a03e0"}[chunkId] + ".chunk.css";
};